<template>
  <b-card no-body>
    <b-card-body>
      <customer-prices-detail
        type="edit"
        :submitting="submitting"
        :values="data"
        @submit="submit"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import { BCard, BCardBody } from 'bootstrap-vue';
import { helper } from '@core/mixins/helper';
import CustomerPricesDetail from '@/views/pages/customers/CustomerPricesDetail.vue';
import useService from '@/auth/service/useService';

export default {
  components: {
    BCard,
    BCardBody,
    CustomerPricesDetail
  },
  mixins: [helper],

  data() {
    return {
      submitting: false,
      data: {},
      customer_id: null,
      price_detail_id: null
    };
  },

  created() {
    this.customer_id = this.$route.params.id;
    this.price_detail_id = this.$route.params.customer_price_id;

    this.getPriceData(this.customer_id, this.price_detail_id);
  },

  methods: {
    submit(data) {
      this.submitting = true;
      delete data.region;

      useService
        .editCustomerRegionPrice(this.customer_id, this.price_detail_id, data)
        .then(response => {
          this.showSuccessMessage(`${response.message}`);
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    },

    getPriceData(customer_id, price_detail_id) {
      this.submitting = true;

      useService
        .getCustomerPriceDetail(customer_id, price_detail_id)
        .then(response => {
          this.data = {
            region: response.data.region,
            currency: response.data.currency,
            price: response.data.price,
            min_val: response.data.minVal,
            max_val: response.data.maxVal,
            price_type: response.data.priceType,
            status: response.data.status
          };
        })
        .catch(messages => {
          if (typeof messages === 'object' && messages && messages.length) {
            messages.forEach(item => {
              this.showErrorMessage(item.message);
            });
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
};
</script>
